// What the server says when it refuses, as the client has to read it.
//
// Every failure comes back carrying a sentence and nothing else — no code, no extensions — so the
// sentence is the contract until there is a real one, and worth naming once rather than spelling
// out at each place that turns on it.
import {CombinedGraphQLErrors} from '@apollo/client'

export const UNAUTHORIZED = 'Unauthorized.'

export const NOT_FOUND = 'Record not found'

export const BAD_REQUEST = 'Bad request.'

export const SEALED = 'Locked is sealed.'

export const NAME_TAKEN = 'That name is already taken here.'

// Why an import from Google Drive couldn't start. Each is said to the person as it stands.
export const IMPORT_RUNNING = 'An import is already running.'

export const IMPORT_TOO_LARGE = 'An import can bring in at most 5 GB at a time.'

export const STORAGE_FULL = "There isn't enough storage left for this import."

export const PROVIDER_BUSY = 'The provider is busy. Try again in a few minutes.'

export const PROVIDER_REFUSED = 'The provider refused the request.'

// Why a post on X has nothing to add.
export const NOT_A_POST = "That isn't a link to a post on X."

export const POST_NOT_FOUND = 'This post has been deleted, or its link is wrong.'

export const POST_HIDDEN = "X only shows this post to people signed in to X, usually because it's marked sensitive or its account is protected."

export const POST_WITHOUT_MEDIA = 'This post has no photos or videos to add.'

export const says = (error, sentence) => (
  CombinedGraphQLErrors.is(error) && error.errors.some(({message}) => message === sentence)
)
